<template>
  <div class="text-green-600 py-2 w-max">
    <h1 class="text-3xl font-semibold">Pasuwādojenerēta</h1>
    <p class="font-light text-green-600 text-sm leading-none">
      A Tools for generator your securily password
    </p>
  </div>
</template>

<script>
export default {
  name: "Title",
};
</script>